var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1418_403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0009 39.4286C30.731 39.4286 39.4295 30.7301 39.4295 20C39.4295 9.26988 30.731 0.571396 20.0009 0.571396C9.27075 0.571396 0.572266 9.26988 0.572266 20C0.572266 30.7301 9.27075 39.4286 20.0009 39.4286Z",
    fill: "#E34506",
    stroke: "#E34506",
    strokeWidth: 1.51429
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0001 15.9999L20.0001 21L12.0001 15.9999V14L20.0001 18.9999L28.0001 14M28.0001 12H12.0001C10.8901 12 10 12.8899 10 14V26C10 26.5304 10.2108 27.0391 10.5858 27.4143C10.9609 27.7893 11.4696 28 12.0001 28H28.0001C28.5306 28 29.0393 27.7893 29.4143 27.4143C29.7894 27.0391 30.0002 26.5304 30.0002 26V14C30.0002 13.4696 29.7894 12.9607 29.4143 12.5857C29.0393 12.2106 28.5306 12 28.0001 12Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1418_403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgImg);
export default __webpack_public_path__ + "static/media/Msg-Img.12976d96e6a06d1e14bcfbb8e948b5b5.svg";
export { ForwardRef as ReactComponent };